export function testimonialsPagination() {
    $(window).on("load", function () {
        const header = $(".header");
        let $testimonials = $('.testimonials');

        $testimonials.on('click', '.pagination a', function (e) {
            e.preventDefault();

            let data = {
                'action': 'pagination_testimonials',
                'paged': $(this).attr('data-num')
            };

            $.ajax({
                url: ajaxvars.ajaxurl,
                data: data,
                type: 'POST',
                success: function (response) {
                    $testimonials.find('.container').html(response);

                    $("html, body").animate({scrollTop: $testimonials.offset().top - header.innerHeight()}, 500);
                },
            });
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/testimonialsPagination.js